export const APP_ROUTER = {
    LOGIN: '/auth/login',
    MainPage: '/',
    ReJoinPage: '/auth/re-join',
    UserManagement: '/user-list',
    NotAuthorized: '/401',
    Companies: '/services/companies',
    DigitalAuthentication: '/services/license/digital-authentication',
    DigitalProduct: '/services/license/DigitalProduct/Requests',
    RequestDetail:'/requests/requestdetails',
    RequestDetailView:'/requests/requestdetails',
    CompanyDetailsPage: (id: string) => `/services/companies/${id}`,
    
  }
